const ReferralFaqContent = [
  {
    title: 'I would like to speak to someone. How do I contact Autzu?',
    info: [
      {
        pretext:
          'Our customer care team is here for you 24/7! Open the Autzu app, navigate to the "Support" section at the bottom of the screen, and submit a support ticket. We will be in touch promptly to help answer any questions you may have.'
      }
    ]
  }
];

export default ReferralFaqContent;



// WEBPACK FOOTER //
// ./src/components/Static/NewGeneralFaq/ContactFaqContent.js